<template>
  <div class="link">
    <a :href="linkUrl" target="_blank"
      >{{ label }}
      <arrow-right-icon v-if="dir == 'ltr'"/>
      <arrow-left-icon v-else-if="dir == 'rtl'"/>
      <arrow-icon
    /></a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ArrowLeftIcon from '@/assets/left-arrow.svg'
import ArrowRightIcon from '@/assets/arrow.svg'

export default {
  components: {
    ArrowLeftIcon,
    ArrowRightIcon,
  },
  props: {
    linkUrl: String,
    label: String,
  },
  computed: {
    ...mapGetters({
      dir: 'app/direction',
    }),
  },
}
</script>

<style lang="scss" scoped>
.link {
  display: flex;

  a {
    text-decoration: none;
    color: $c-success-green;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;

    &:hover {
      color: darken($color: $c-success-green, $amount: 5%);
      svg {
        fill: darken($color: $c-success-green, $amount: 5%);
      }
    }

    svg {
      fill: $c-success-green;
      width: 24px;
      padding-left: 7px;
    }
  }
}

html.is-rtl {
  .link {
    a {
      svg {
        padding-right: 7px;
        padding-left: unset;
      }
    }
  }
}
</style>
